import type { PropertyFilters } from '~/core/entities/property/filters';

export interface RoomFilterMapper {
	(filters: PropertyFilters, amount: number): PropertyFilters;
}

export type RoomType = 'bedrooms' | 'suites' | 'parkingSpots' | 'bathrooms';
export type CategoryType = 'Quartos' | 'Suítes' | 'Vagas' | 'Banheiros';

export const createRoomFilterMapper = <T extends string>(
	mapping: Record<T, RoomType>
): Record<T, RoomFilterMapper> => {
	const mapper = {} as Record<T, RoomFilterMapper>;

	Object.entries(mapping).forEach(([key, roomType]) => {
		mapper[key as T] = (filters, amount) =>
			({
				...filters,
				[roomType as keyof PropertyFilters]: amount
			}) as PropertyFilters;
	});

	return mapper;
};
